<template>
  <ion-page>
    <master-layout pageTitle="مأموریت ها">
      <IonCardContent>
        <DataTable :orderBy="2" orderType="desc" :card="true" auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
      </IonCardContent>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
 IonPage,IonCardContent
} from "@ionic/vue";


export default {
  data()
  {
    return {
      headers: [
        'شماره',
         'عنوان',
        'تاریخ شروع',
        'تاریخ پایان',
        'نوع',
        'وضعیت',
        'امکانات',
      ],
      route:null,
    };
  },
  async created()
  {
    this.route = 'mission/listAjax';
  },
  components: {
    DataTable, IonPage,IonCardContent
  },
};
</script>

<style scoped>

</style>